import { createRefPath } from "global/firestoreData/appData/appRefPaths";
import { _showAppLogs } from "../contexts/LogContext";
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "./reducerHelpers/dispatchProps";

export const rts = {
  handleSet_eventAppUsers: 'handleSet_eventAppUsers',
  handleUpdate_tempAccess: 'handleUpdate_tempAccess',
  ...grts
}

export const appUsersReducerInitialState = (initState) => {
  return { ...initState }
};

export const appUsersReducer = (state, action) => {

  const { database_fns } = state
  const { type, dispatch } = action

  _showAppLogs.reducerTypes && console.log('✔️ appUsersReducer', type)

  switch (type) {

    case rts.handleSet_eventAppUsers:
      return { ...state, eventAppUsers: action.eventAppUsers }

    case rts.handleUpdate_tempAccess:
      const _scanData = JSON.parse(action.scanData)
      const { docId, appUserId, golferKey, firstName, lastName } = _scanData ?? {}
      if (docId) {
        if (storedUserId && golferKey) {
          const refPath = createRefPath(['_accessTemp', docId])
          const dataToUpdate = {
            [appUserId]: {
              allowed: true,
              firstName,
              lastName,
              golferKey
            }
          }
          database_fns.doc_set(refPath, dataToUpdate, true)
        }
      }
      return { ...state }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation })

    default:
      return { ...state }
  }
}

export const appUsersHandlers = (dispatch) => {
  return {
    handleUpdate_tempAccess: (scanData) => { dispatch({ type: rts.handleUpdate_tempAccess, dispatch, scanData }) },
    handleInit_appUsers: (appUserCollections) => { dispatch({ type: rts.handleInit_appUsers, dispatch, appUserCollections }) },
    handleSet_eventAppUsers: (eventAppUsers) => { dispatch({ type: rts.handleSet_eventAppUsers, dispatch, eventAppUsers }) },
    handleCreate_clientProfileUrls: (aps_global, appUserCollection, appDataDocuments, callback) => { dispatch({ type: rts.handleCreate_clientProfileUrls, dispatch, aps_global, appUserCollection, appDataDocuments, callback }) },
    ...responseHandlers(dispatch)
  }
} 